import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';

export function trackProductClick({
  searchTerm,
  searchMethod,
  resultsFilters,
  location,
  currency,
  clickedProduct,
}: {
  searchTerm?: string;
  searchMethod?: string;
  resultsFilters?: {
    category?: string;
    price?: {
      min?: string;
      max?: string;
    };
  };
  location: string;
  currency: string;
  clickedProduct: Array<EcommerceCartItem> | EcommerceCartItem | undefined;
}) {
  pushToDataLayer({
    event: 'select_item',
    searchTerm: searchTerm,
    searchMethod: searchMethod,
    filters: resultsFilters,
    location: location,
    ecommerce: {
      currency,
      items: Array.isArray(clickedProduct) ? clickedProduct : [clickedProduct],
    },
  });
}
